import { setcountry } from "src/store/slices/country-slice";
import { store } from "src/store/store";

export const fetchCountryList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_HTTPS_URL}/countries`,
      { method: "GET" }
    );

    if (!response.ok) throw new Error(`Error: ${response.statusText}`);

    const result = await response.json();
    store.dispatch(setcountry(result));
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
